<div class="header">
  <strong>NOME</strong>
  <strong>CLIENTE</strong>
  <strong>CRIADO POR</strong>
  <strong>DATA DA CRIAÇÃO</strong>
  <strong>STATUS</strong>
  <strong *ngIf="hasSupervisorRole">AÇÕES</strong>
</div>
